import { isDev, normalize, toLocale, hashString, inIframe, clone, throttle } from 'global/js/apps.js'
import Byline from '../components/Byline'
import colors from 'global/css/_contexte.apps.colors.2.0.scss'
import Chart2022 from '../components/Chart2022'
import Copyrights from 'global/components/Copyrights'
import Feedback from 'global/components/Feedback'
import HeaderPage from '../components/HeaderPage'
import Lazyload from 'global/components/Lazyload'
import Loader from 'global/components/Loader'
import Radios from 'global/components/Radios'
import Tabs from 'global/components/Tabs'
import TwitterBird from '../assets/twitter.svg'

const chartDataUrls = {
	firstRound: {
		candidates: 'https://apps.contexte.com/data/ctx-presi-polls/chart_candidates.json',
	},
	runoffs: {
		candidates: 'https://apps.contexte.com/data/ctx-presi-polls/chart_runoff.json',
	},
}

const urlCandidatesList = 'https://apps.contexte.com/data/ctx-dzc/2021-03-presi-polls.json'
const urlPollsList = 'https://apps.contexte.com/data/ctx-presi-polls/polls_light.json'
const urlTwitter = 'https://twitter.com/pollotron2022'
const contexteStoryUrl = 'https://www.contexte.com/article/pouvoirs/agregateur-de-sondages-de-la-presidentielle-2022_128913.html'
const contexteFeedbackFormUrl = 'https://contexte.typeform.com/to/kvhgKz&origin=pollotron'
const contexteHomeUrl = 'https://www.contexte.com'


const contexteAuthor = {
	name: 'Yann Guégan',
	url: 'https://www.contexte.com/equipe/yann-guegan-67378.html'
}
require('iframe-resizer/js/iframeResizer.contentWindow.min.js')
export default {
	name: 'Polls',
	components: { 
		Byline,
		ChartErrors: () => import('../components/ChartErrors'),
		Chart2017: () => import('../components/Chart2017'),
		Chart2022,
		ChartFamilies: () => import('../components/ChartFamilies'),
		Copyrights,
		Feedback,
		HeaderPage,
		Lazyload,
		Loader, 
		PollsList: () => import('../components/PollsList'),
		Radios,
		Tabs,
		TwitterBird,
	},
	data: function() {
		return {
			deadlines: {
				current: {
					firstRound: '2022-04-10',
					runoff: '2022-04-24'
				},
				previous: {
					firstRound: '2017-04-23',
					runoff: '2017-05-07'
				},
			},
			scrollY: 0,
			isDev: isDev(),
			mode: 'full',
			mobile: false,
			smallScreen: false,
			largeScreen: false,
			ready: false,
			innerWidth: window.innerWidth,
			pollsChart: '',
			defaultCandidatesNb: 5,
			minCandidateScore: 0,
			prepareAll2022Charts: false,
			contexte: {
				urls: {
					story: contexteStoryUrl,
					home: contexteHomeUrl,
					feedback: contexteFeedbackFormUrl,
				},
				author: contexteAuthor,
			},
			breakpoints: {
				mobile: 600,
				smallScreen: 900,
				largeScreen: 1300,
			},
			raw: {
				infos: {
					candidates: [],
					events: [],
					candidates2017: [],
					why: [],
					polls: [],
					organizations: [],
				},
				chart: [],
				chartRunoffs: [],
			},
			urls: {
				infos: urlCandidatesList,
				chartFirstRound: chartDataUrls.firstRound,
				chartRunoffs: chartDataUrls.runoffs.candidates,
				pollsList: urlPollsList,
			},
			activeCandidatesId: [],
			candidatesInUrl: [],
			mainWidth: 0,
			nbPollsInList: null,
			maxPollsAge: 365,
			all2022ChartsData: [],
			twitter: {
				name: '@Pollotron2022',
				url: urlTwitter,
				image: TwitterBird,
			}
		}
	},
	created() {

		// Check display mode (single or all) in URL parameters
		let urlParams = new URLSearchParams(document.location.search)
		if (!!urlParams.get('mode')) this.mode = urlParams.get('mode')
		// if (this.isDev) this.mode = 'light'
		if (!!urlParams.get('candidates')) {
			let candidatesInUrl = urlParams.get('candidates').split('|')
			candidatesInUrl = candidatesInUrl.slice(0,6)
			candidatesInUrl.map(candidatesInUrl => {
				this.candidatesInUrl.push(normalize(candidatesInUrl, true))
			})
		}
		// if (this.isDev) this.mode = 'light'
		if (this.mode == 'light') {
			let $body = document.querySelector('body')
			$body.classList.add('--noborder')
			this.minCandidateScore = 10
		}

		// Set settings according to screen size
		if (this.innerWidth <= this.breakpoints.mobile) this.mobile = true
		if (this.innerWidth <= this.breakpoints.smallScreen) this.smallScreen = true
		if (this.innerWidth >= this.breakpoints.largeScreen) this.largeScreen = true
		// if (this.mobile) {
		if (inIframe() && this.mode == 'full') {

			let $iframe = parent.document.querySelector('iframe[src*="/apps/"]')
			if (this.isDev) $iframe = parent.document.querySelector('iframe')
			$iframe.style.marginTop = '0px';
			$iframe.style.height = 'calc(100vh - 40px)'
		}
		// } 

		// Get infographics data (candidates info, first round charts and run-offs charts)
		let urls = [
			this.urls.infos,
			this.urls.chartFirstRound.candidates,
			this.urls.chartRunoffs,
			this.urls.pollsList,
		]
		if (this.isDev) {
			console.log('Getting data:')
			Array.from(urls).map(url => console.log(url))
		}
		Promise.all(urls.map(url =>
			fetch(url, {cache: 'no-store'}).then(resp => resp.json())
		))
		.then(jsons => {
			if (this.isDev) jsons.map(json => {
				console.log(json)
			})
			this.raw.infos.candidates = jsons[0].candidates
			this.raw.infos.candidates2017 = jsons[0].candidates2017
			this.raw.infos.events = jsons[0].events
			this.raw.infos.why = jsons[0].why
			this.raw.infos.organizations = jsons[0].companies
			this.raw.infos.polls = jsons[3]
			this.raw.chart = jsons[1]
			this.raw.chartRunoffs = jsons[2]

			// Prepare the default chart’s data only 
			this.prepare2022ChartsData('initial')
			this.finishInit()
		})
		.catch((err) => {
			console.log(err)
		})
	},
	computed: {
		runoffs: function() {
			let limit = new Date('2021-04-10')
			let list = this.raw.chartRunoffs.reduce((acc, chart) => {
				let latest = new Date(chart.dots[0].data[0].x)
				if (latest < limit) return acc
				// let latestAge = Math.round((new Date() - latest) / 1000 / 3600 / 24)
				// if (latestAge > this.maxPollsAge) return acc

				let hasQuitter = false
				Array.from([0,1]).forEach(pos => {
					let candidate = this.raw.infos.candidates.find(c => c.full_name == chart.dots[pos].name)
					if (candidate.quitter == 'oui') hasQuitter = true

				})

				return acc.concat({				
					code: chart.code,
					wording: chart.name.replace(' – ','–'),
					inactive: false,
					hasQuitter: hasQuitter,
					
				})
			}, []).sort((a,b) => a.hasQuitter - b.hasQuitter)
			let initial = this.raw.chartRunoffs[0].code

			return { default: initial, list: list }
		},
		info: function() {
			let lastHypo = this.hypos[this.hypos.length - 1]
			let date = new Date(lastHypo.date)
			return {
				lastPoll: {
					date: date.toLocaleString('fr-FR', { day: 'numeric', month: 'long' }),
					organization: lastHypo.organization,
				},
				nbPolls: this.hypos.length,
				remainingDays: this.remainingDays,
				contexte: this.contexte,
				twitter: this.twitter,
			}
		},
		remainingDays: function() {
			let today = new Date()
			let firstRoundDate = new Date(this.deadlines.current.runoff)

			return Math.round((firstRoundDate - today) / ( 60*60*24) / 1000) + 1
		},
		images: function() {
			return this.candidates.reduce((agg, candidate) => {
				if (!candidate.s3image) return agg
				return agg.concat({
					name: candidate.last_name,
					author: candidate.s3image.copyright,
				})
			}, [])
		},
		candidates: function() {
			let candidates = clone(this.raw.infos.candidates.filter(c => c.keep == 'oui'))
			let allCharts = [this.raw.chart].concat(this.raw.chartRunoffs) 
			candidates.map(candidate => {

				// Prepare candidate misc infos
				candidate['last'] = 0
				candidate['min'] = 0
				candidate['lastTxt'] = 'nc'
				candidate.party_pos = parseInt(candidate.party_pos)

				// Create candidate ID
				candidate['id'] = Math.abs(hashString(candidate.last_name))

				// Prepare candidate polls
				candidate['polls'] = []
				allCharts.forEach(chart => {
					let dots = chart.dots.find(d => d.name == candidate.full_name)
					if (!!dots) {
						let converted = this.convertDotsToPolls(dots)
						converted.forEach(poll => {
							candidate['polls'].push(poll)
						})
					}
				})
				candidate.polls.sort((a,b) => b.date - a.date)

				// Get candidate last available score
				let thisLine = allCharts[0].lines.find(l => l.name == candidate.full_name)
				if (!thisLine) candidate.min = candidate.polls[0].score
				if (!!thisLine && !!thisLine.data.length) {
					candidate.last = thisLine.data[thisLine.data.length - 1].y
					candidate.min = candidate.last
				}
				candidates.sort((a,b) => b.last - a.last)

			})

			if (this.mode == 'light' && !!this.candidatesInUrl.length) return candidates.filter(c => this.candidatesInUrl.includes(normalize(c.last_name, true)))
			return candidates.filter(c => c.min >= this.minCandidateScore)
		},
		pallet: function() {
			let pallet = []
			for (let key in colors) {
				if (key.includes('dark') && !key.includes('grey')) pallet.push(colors[key])
			}
			return pallet 
		},
		hypos: function() {
			let hypos = this.raw.infos.polls.reduce((acc, poll) => {
				return acc.concat(poll.tours.reduce((acc2, round) => {
					return acc2.concat(round.hypotheses.reduce((acc3, hypo) => {
						let fixedHypoId = hypo.id.replace('deuxiemetour', 'runoff')
						let newItem = {
							...hypo,
							pollId: poll.id,
							roundName: round.tour,
							hypoId: hypo.id,
							date: poll.fin_enquete,
							population: poll.population,
							organization: poll.nom_institut,
							link: poll.lien,
							rolling: poll.rolling,
							organizationGrade: 'NC',
							candidates: [],
						}
						//if (newItem.roundName == 'Deuxième tour')  console.log(fixedHypoId)
						this.candidates.forEach(candidate => {
							candidate.polls.map(candidatePoll => {
								if (candidatePoll.info.hypoId == fixedHypoId) {
									newItem.candidates.push({
										name: candidate.full_name_clean,
										id: candidate.id,
										score: candidatePoll.score,
										min: candidatePoll.min,
										max: candidatePoll.max,
									})
								}
							})
						})
					
						let thisOrg = this.raw.infos.organizations.find(o => o.name == poll.nom_institut)
						if (!!thisOrg) newItem.organizationGrade = thisOrg.grade
						
						return acc3.concat(newItem)
					}, []))
				}, []))				
			}, [])

			return hypos.sort((a,b) => a.date.localeCompare(b.date))
		},
	},
	methods: {
		prepare2022ChartsData: function(state) {
			let charts = []
			Array.from(['a-year', 'three-months']).forEach(ts => {
				charts.push({ round: 'round1', code: '', candidates: [], timespan: ts })
				this.runoffs.list.forEach(runoff => charts.push({
					round: 'round2',
					code: runoff.code,
					candidates: [],
					timespan: ts,
					start: null,
					end: null,
				}))
			})	

			if (state == 'initial') charts = charts.filter(c => c.code == 'emmanuelmacron_marinelepen' && c.timespan == 'three-months' )
			if (state == 'final') charts = charts.filter(c => c.code != 'emmanuelmacron_marinelepen' || c.timespan != 'three-months' )

			charts = charts.forEach(chart => {
				// console.log('Creating data for chart:', chart.round, chart.code, chart.timespan)
				let rawChart = this.raw.chart
				if (chart.round == 'round2') rawChart = this.raw.chartRunoffs.find(c => c.code == chart.code)

				if ('dots' in rawChart || 'lines' in rawChart) {

					// Set date timespan
					let mostRecent = new Date('2022-04-25')
					chart.end = mostRecent.toISOString().substring(0, 10)

					let oldest = new Date('2022-04-25')
					let duration = 365
					if (chart.timespan == 'three-months') duration = 90
					oldest.setDate(oldest.getDate()-duration)
					chart.start = oldest.toISOString().substring(0, 10)
					this.candidates.forEach(candidate => {

						// Prepare candidate trend line
						let cLine = null
						let line = rawChart.lines.find(l => l.name == candidate.full_name)
						if (!!line) {
							cLine = clone(line)
							cLine['label'] = candidate.last_name
							cLine['labelShort'] = candidate.short_name
							cLine['color'] = candidate.party_color
							cLine.data = cLine.data.filter(d => {
								let date = new Date(d.x)
								return date >= oldest && date <= mostRecent
							})
						}

						// Prepare candidate area
						let cArea = null
						let area = rawChart.areas.find(l => l.name == candidate.full_name)
						if (!!area) {
							cArea = clone(area)
							cArea['label'] = candidate.last_name
							cArea['color'] = candidate.party_color
							cArea.data = cArea.data.filter(d => {
								let date = new Date(d.x)
								return date >= oldest && date <= mostRecent
							})
						}

						// Prepare candidate dots
						let cEntries = []
						let dots = rawChart.dots.find(d => d.name == candidate.full_name)

						if (!!dots) {
							let cDots = clone(dots)
							cDots.data = dots.data.filter(entry => {
								let date = new Date(entry.x)
								return date <= mostRecent && date >= oldest
							})
							cDots.data.forEach(entry => {
								let thisHypo = this.hypos.find(h => h.hypoId == entry.info.hypoId)
								let date = new Date(thisHypo.date)
								let html = '' + 
								'<div class="tt__score">' +
								'	' + toLocale(entry.y, 3) + '\xa0%' +
								'</div>' +
								'<div class="tt__candidate" style="color: ' + candidate.party_color + ' ">' +
								'	' + candidate.last_name + '</div>' +
								'</div>' + 
								'<div class="tt__details">' +
								'	ME\xa0: entre ' + toLocale(entry.info.min, 2) + '\xa0% et ' + toLocale(entry.info.max, 2) + '\xa0%<br>' +
								'	' + (thisHypo.hypothese != 'Hypothèse sans nom' && !!thisHypo.hypothese ? thisHypo.hypothese + '<br>' : '') +
								'	' + thisHypo.organization + ', ' + date.toLocaleString('fr-FR', { day: 'numeric', month: 'long' }).replace(/^(\d+)\s(.+)/,'$1\xa0$2') +
								'</div>'
								let delay = parseInt(Math.random()*10)/10
								cEntries.push({
									label: candidate.last_name,
									color: candidate.party_color,
									html: html,
									x: entry.x,
									y: entry.y,
									id: thisHypo['hypoId'] + normalize(candidate.last_name),
									delay: delay,
								})

							})
						}
						chart.candidates.push({
							full_name: candidate.full_name,
							line: cLine,
							dots: cEntries,
							area: cArea,
						})
					})
					this.all2022ChartsData.push(chart)
				}
			})
		},
		convertDotsToPolls: function(dots) {
			let polls = []
			dots.data.map(entry => {
				let date = new Date(entry.info.date)
				let dateTxt = date.toLocaleString('fr-FR', {
					day: 'numeric',
					month: 'long',
					year: 'numeric',
				})
				polls.push({
					score: entry.y,
					min: entry.info.min,
					max: entry.info.max,
					scoreTxt: toLocale(entry.y, 2),
					info: entry.info,
					date: date,
					dateTxt: dateTxt,
				})
			})

			return polls
		},
		finishInit: function() {
			this.ready = true
			this.$nextTick(() => {
				this.mainWidth = this.$refs.main.getBoundingClientRect().width
				this.mainWidth -= parseInt(getComputedStyle(this.$refs.main).paddingLeft)
				this.mainWidth -= parseInt(getComputedStyle(this.$refs.main).paddingRight)
				setTimeout(() => {
					this.prepare2022ChartsData('final')
				}, 500)
				
			})
			throttle(window.onscroll = () => {
				this.scrollY = window.scrollY 
			}, 300)
		}
	},
}